module.exports = "/_next/static/images/Plan-3-8ff77c8526abfa8b142cf28d11927ab0.png";